import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { IconProps } from '../icons'

const BankAccountWithColor = ({
  size = 36,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 36 36"
    fill="none"
    {...props}
  >
    <Rect width={36} height={36} rx={18} fill="#fff" />
    <G clipPath="url(#a)">
      <Path
        d="m26.803 11.444-8.455-5.343a.651.651 0 0 0-.696 0l-8.455 5.343a.652.652 0 0 0 .348 1.203h16.91a.652.652 0 0 0 .348-1.203ZM25.343 13.036h-2.268a.652.652 0 0 0-.651.652v9.543c0 .36.291.652.651.652h2.268c.36 0 .651-.292.651-.652v-9.543a.652.652 0 0 0-.651-.652ZM19.134 13.036h-2.268a.652.652 0 0 0-.651.652v9.543c0 .36.291.652.651.652h2.268c.36 0 .651-.292.651-.652v-9.543a.652.652 0 0 0-.651-.652ZM12.88 13.036h-2.268a.652.652 0 0 0-.651.652v9.543c0 .36.292.652.652.652h2.267c.36 0 .652-.292.652-.652v-9.543a.652.652 0 0 0-.652-.652Z"
        fill="#AAD5FF"
      />
      <Path
        d="M12.88 13.036h-1.134v10.847h1.134c.36 0 .652-.292.652-.652v-9.543a.652.652 0 0 0-.652-.652Z"
        fill="#6DB6FF"
      />
      <Path
        d="M27.663 11.344H8.337c-.669 0-1.213.544-1.213 1.213v1.247c0 .67.544 1.214 1.213 1.214h19.326c.669 0 1.213-.545 1.213-1.214v-1.247c0-.67-.544-1.213-1.213-1.213Z"
        fill="#389CFF"
      />
      <Path
        d="M26.455 21.955H9.545a.652.652 0 0 0-.651.652v2.37c0 .36.292.652.651.652h16.91c.36 0 .651-.292.651-.652v-2.37a.652.652 0 0 0-.651-.652Z"
        fill="#AAD5FF"
      />
      <Path
        d="M28.224 24.326H7.775a.652.652 0 0 0-.651.652v2.37c0 .36.291.652.651.652h20.45c.36 0 .651-.292.651-.651v-2.371a.652.652 0 0 0-.652-.652Z"
        fill="#389CFF"
      />
      <Path
        d="M27.08 12.177a.652.652 0 0 1-.625.47H18V6a.65.65 0 0 1 .348.1l8.296 5.244.159.1a.651.651 0 0 1 .277.732ZM25.343 13.036h-1.134v10.847h1.134c.36 0 .651-.292.651-.652v-9.543a.652.652 0 0 0-.651-.652ZM19.134 13.036H18v10.847h1.134c.36 0 .651-.292.651-.652v-9.543a.652.652 0 0 0-.651-.652Z"
        fill="#6DB6FF"
      />
      <Path
        d="M28.876 12.557v1.247c0 .67-.544 1.213-1.213 1.213H18v-3.673h9.663c.669 0 1.213.544 1.213 1.213Z"
        fill="#2E85DD"
      />
      <Path
        d="M27.106 22.607v2.37c0 .36-.291.652-.652.652H18v-3.674h8.454c.36 0 .652.292.652.652Z"
        fill="#6DB6FF"
      />
      <Path
        d="M28.876 24.977v2.371c0 .36-.291.652-.651.652H18v-3.674h10.225c.36 0 .651.291.651.651Z"
        fill="#2E85DD"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(7 6)" d="M0 0h22v22H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default BankAccountWithColor
